export const installmentsActivation = {
    showLinkDescription: true,
};
